import React from "react";
import { brands } from "../mock";
import Reveal from "./Reveal";

export default function TrustedBy() {
  const loop = [...brands, ...brands];
  return (
    <section className="py-16 md:py-20 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center mb-10">
          <p className="overline text-sm mb-1">We are</p>
          <h2 className="section-title text-3xl md:text-4xl">
            &ldquo;Trusted by the Best&rdquo;
          </h2>
        </Reveal>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-slate-50 to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-slate-50 to-transparent" />
        <div className="marquee-track gap-4 py-2">
          {loop.map((b, i) => (
            <div
              key={`${b}-${i}`}
              className="shrink-0 h-16 min-w-[150px] px-6 flex items-center justify-center bg-white rounded-xl border border-slate-100 shadow-sm"
            >
              <span className="font-head font-semibold text-slate-600 whitespace-nowrap">{b}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
